var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"actionButton",on:{"click":_vm.doClick}},[_c('div',{staticClass:"mark"},[_c('IconBase',[_c('IconSort')],1)],1),_c('div',{staticClass:"txt"},[_vm._v("並べ替え")])])
}
var staticRenderFns = []

export { render, staticRenderFns }